export function update(metaSocialRecord) {
  document.title = metaSocialRecord.title

  updateMetaTag('meta-application-name', metaSocialRecord.title)
  updateMetaTag('meta-description', metaSocialRecord.description)
  updateMetaTag('meta-keywords', metaSocialRecord.keywords)

  updateMetaTag('meta-item-name', metaSocialRecord.title)
  updateMetaTag('meta-item-description', metaSocialRecord.description)
  updateMetaTag('meta-item-image', metaSocialRecord.image)

  updateMetaTag('twt-title', metaSocialRecord.title)
  updateMetaTag('twt-description', metaSocialRecord.description)
  updateMetaTag('twt-image', metaSocialRecord.image)
  updateMetaTag('twt-image-alt', metaSocialRecord.title)

  updateMetaTag('og-title', metaSocialRecord.title)
  updateMetaTag('og-url', metaSocialRecord.url)
  updateMetaTag('og-image', metaSocialRecord.image)
  updateMetaTag('og-image-type', imageType(metaSocialRecord.image))
  updateMetaTag('og-image-alt', metaSocialRecord.title)
  updateMetaTag('og-description', metaSocialRecord.description)

  document.head.querySelector('link[rel="canonical"]').href = metaSocialRecord.url
}

function updateMetaTag(tagName, value) {
  document.head.querySelector(`meta[id="${tagName}"]`).content = value
}

// Mirrors SharedView.meta_social_image_type/1. The dynamic /social/* routes
// have no extension and are always PNG.
function imageType(image) {
  const extension = (image || '').split('?')[0].split('.').pop().toLowerCase()

  switch (extension) {
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg'
    case 'gif':
      return 'image/gif'
    case 'webp':
      return 'image/webp'
    case 'svg':
      return 'image/svg+xml'
    default:
      return 'image/png'
  }
}
